/* INTEGY V627 — policy navigation + legacy Ajax-modal safety owner. */
(function () {
  'use strict';

  var HANDLES = {
    'terms-of-service': true,
    'shipping-policy': true,
    'refund-policy': true
  };

  function rootPath() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root;
    root = String(root || '/');
    if (!root.startsWith('/')) root = '/';
    return root.replace(/\/+$/, '/') || '/';
  }

  function policyUrl(handle) {
    return new URL(rootPath() + 'policies/' + handle, window.location.origin).href;
  }

  function directNavigate(handle) {
    if (!HANDLES[handle]) return;
    var url = policyUrl(handle);
    try {
      /* Direct top-level assignment: no anchor and no form for Empire to Ajax-intercept. */
      window.top.location.href = url;
    } catch (error) {
      window.location.href = url;
    }
  }

  function policyHandle(control) {
    var handle = String(control && control.getAttribute('data-integy-v627-policy') || '').toLowerCase();
    return HANDLES[handle] ? handle : '';
  }

  /* Capture before Empire/legacy delegated click owners. */
  window.addEventListener('click', function (event) {
    var control = event.target && event.target.closest
      ? event.target.closest('[data-integy-v627-policy]')
      : null;
    if (!control) return;
    var handle = policyHandle(control);
    if (!handle) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    directNavigate(handle);
  }, true);

  function looksLikePolicy(content) {
    if (!content) return false;
    var text = String(content.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!text) return false;
    return text.indexOf('refund policy') >= 0 ||
      text.indexOf('return policy') >= 0 ||
      text.indexOf('shipping policy') >= 0 ||
      text.indexOf('terms of service') >= 0 ||
      text.indexOf('integy return product conditions') >= 0 ||
      text.indexOf('item pricing') >= 0 && text.indexOf('sales tax') >= 0;
  }

  function markPolicyModal() {
    document.querySelectorAll('[data-modal-container], [data-modal-container-1]').forEach(function (modal) {
      var content = modal.querySelector('[data-modal-content]');
      if (!looksLikePolicy(content)) return;
      modal.classList.add('integy-v627-policy-modal');
      var inner = modal.querySelector('[data-modal-inner]');
      if (inner) {
        inner.style.setProperty('background-color', '#141b21', 'important');
        inner.style.setProperty('color', '#e8eef3', 'important');
      }
      if (content) {
        content.style.setProperty('background-color', '#0f1419', 'important');
        content.style.setProperty('color', '#e8eef3', 'important');
      }
    });
  }

  var observer = new MutationObserver(function (records) {
    var relevant = records.some(function (record) {
      return record.type === 'childList' && record.addedNodes && record.addedNodes.length;
    });
    if (relevant) window.requestAnimationFrame(markPolicyModal);
  });

  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markPolicyModal, { once: true });
  } else {
    markPolicyModal();
  }
})();
